<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :inline="true" :rules="rules">
        <div class="block">
          <div class="contit">基础信息</div>
          <!-- 选择车牌按钮 -->
          <VehicleSelect :modalList="cars" @onChecked="onChecked">
            <template #start>
              <div class="sinput">
                <SearchField :form="sform" :formCtrl="sformCtrl" @onSearch="onSearch" @onReset="onModalReset"
                  @onChange="onSearchItemChange" />
              </div>
            </template>
          </VehicleSelect>
          <!-- 其他控件 -->
          <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">运单信息</div>
          <FormItem v-for="(c, i) in formCtrlOrder" :key="'formItemo1' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          <div>
            <FormItem v-for="(c, i) in formCtrlOrder3" :key="'formO2Item2' + i" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </div>
          <!-- 重量控件 -->
          <span v-show="form.pricing_id == 1">
            <FormItem v-for="(c, i) in formCtrlWeight" :key="'formItemWeight' + i" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </span>
        </div>

        <div class="block">
          <div class="contit">备注信息</div>
          <FormItem v-for="(c, i) in formCtrl2" :key="'form2Item' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange">
            <template #end>
              <PaymentSwitch v-show="form['repaytime']" :value="form['istime']" @onToggle="onToggle" />
            </template>
          </FormItem>

          <!-- 可变文本域备注 -->
          <FormItem v-for="(c, i) in formCtrl3" :key="'form3Item' + i" :ref="'form3Item' + i" :viewMode="c.viewMode"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput">
          </FormItem>
        </div>

        <ExtraFee :form="form" :formCtrl="formCtrlfee" @onChange="onChange" />
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import orderViewMixin from "../orderViewMixin";

let fromPath = ''

export default {
  mixins: [detailMixin, orderViewMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "运单管理", path: "/order/contract" },
        { name: "合同运单", path: "/order/contract/own/tobe" },
        { name: "合同运单添加" },
      ],
      sform: {
        car_type: undefined,
        license: undefined,
      },
      sformCtrl: [
        {
          label: "车辆类型",
          keyName: "car_type",
          type: "select",
          options: [],
        },
        {
          label: "车牌号",
          keyName: "license",
          type: "text",
        },
      ],
      form: {
        message: '0.00',
        insurance: '0.00',
        fuel: '0.00',
        exceeded: '0.00',
        contractid: null,
        predict_loading_date: null,
        predict_unloading_date: null,
      },
      formCtrl: [
        {
          label: "合同编号",
          keyName: "contractid",
          err: "请选择合同编号",
          type: "select",
          popperClassName: 'contractid',
          options: [],
        },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "text",
          viewMode: true,
        },
        {
          label: "货物名称",
          keyName: "name",
          err: "请选择货物名称",
          type: "text",
          viewMode: true,
        },
      ],
      // 运单信息
      formCtrlOrder: [
        {
          label: "计价方式",
          keyName: "pricing_id",
          type: "select",
          options: [],
          viewMode: true,
        },
        {
          label: "公司单价",
          keyName: "cprice",
          err: "请填写运费单价",
          type: "number",
          viewMode: true,
        },
        {
          label: "司机单价",
          keyName: "dprice",
          err: "请填写承运单价",
          type: "number",
          viewMode: true,
        },
      ],
      formCtrlOrder3: [
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          className: "unton",
          viewMode: true,
        },
        {
          ...this.ctrls.ZhuangHuoRiQi,
        },
        {
          ...this.ctrls.XieHuoRiQi,
        },
      ],
      // 亏吨信息
      formCtrlWeight: [
        {
          label: "客担亏吨(吨)",
          keyName: "ceton",
          err: "请填写客担亏吨",
          type: "number",
        },
        {
          label: "亏吨单价(元/吨)",
          keyName: "dtonprice",
          err: "请填写亏吨单价",
          type: "number",
          tips: "不填写默认不计算亏吨金额",
        },
      ],
      // 预计结款日期
      formCtrl2: [
        {
          label: "预计结款日期",
          keyName: "repaytime",
          err: "请填写预计结款日期",
          type: "date",
          tips: "不填写则默认没有预计结款日期",
          // className: "block",
        },
      ],
      // 附加费用，客户信息费字段不同于自有车辆
      formCtrlfee: [
        // {
        //   label: "信息费",
        //   keyName: "message",
        //   type: "number",
        // },
        // {
        //   label: "保险费",
        //   keyName: "insurance",
        //   type: "number",
        // },
        // {
        //   label: "燃油附加费",
        //   keyName: "fuel",
        //   type: "number",
        // },
        // {
        //   label: "超限附加费",
        //   keyName: "exceeded",
        //   type: "number",
        // },
      ],
      rules: {
        predict_loading_date: [
          { required: true, message: "请选择装货日期", trigger: "blur" },
        ],
        predict_unloading_date: [
          { required: true, message: "请选择卸货日期", trigger: "blur" },
        ],
        contractid: [
          { required: true, message: "请选择合同编号", trigger: "blur" },
        ],
      },
      contract: [],
      cars: [],
    };
  },
  methods: {
    onChecked(arr) {
      console.log(arr)
      this.form.car_list = [...arr]
    },
    onModalReset() {
      this.sform = {
        car_type: undefined,
        license: undefined,
      }
      this.getCar();
    },
    onSearch() {
      this.getCar();
    },
    onSearchItemChange({ key }) {
      // console.log(key)
      if (['car_type'].includes(key)) {
        this.getCar()
      }
    },
    getCar() {
      // this.cars = [];
      let url = "order/searchcar";
      const params = {
        userid: this.user.id,
        ...this.sform
      }
      this.post(url, params, ({ driver }) => {
        // const { msg, data } = res
        // console.log(driver)
        if (driver && driver.length) {
          this.cars = [...driver]
        } else {
          this.cars = []
        }
      }, err => {
        console.log(err)
      })
    },
    onChange({ key, value }) {
      console.log(key, value)
      // console.log(Number(value))
      if (key.includes('additional_fee')) {
        this.ExtraFeeChange(key, value)
      } else if (key === 'contractid') {
        this.$set(this.form, key, value)
        this.contract.map(v => {
          if (value === v.id) {
            this.$set(this.form, 'shname', v.shname)
            this.$set(this.form, 'shipperid', v.shipperid)
            this.$set(this.form, 'name', v.name)
            this.$set(this.form, 'nid', v.nid)
            this.$set(this.form, 'pricing_id', v.pricing_id)
            this.$set(this.form, 'cprice', v.cprice)
            this.$set(this.form, 'dprice', v.dprice)
            this.$set(this.form, 'coaddress', v.coaddress)
            this.$set(this.form, 'enaddress', v.enaddress)
            // console.log({...v})
          }
        })
      } else if (['invoice', 'uninvoice'].includes(key) && value && value[0].response) {
        this.$set(this.form, key, value[0].response.photo)
      } else if (key === 'shipperid') {
        this.$set(this.form, key, value)
        if (this.pcustom && this.pcustom.length) {
          this.pcustom.map(v => {
            if (value === v.id) {
              this.$set(this.form, 'shname', v.name)
              // console.log({...v})
            }
          })
        }
      } else {
        this.$set(this.form, key, value)
      }
      // 表单赋值之后再计算亏吨重量
      if (['inton', 'unton'].includes(key)) {
        this.calcKuiton()
      }
      // console.log('form', { ...this.form });
    },
    calcKuiton() {
      const inton = this.form['inton'];
      const unton = this.form['unton'];
      // console.log(inton, unton)
      if (inton && unton) {
        this.$set(this.form, 'kuiton', (inton - unton).toFixed(2) + '吨')
      }
    },
    onToggle(boo) {
      // console.log(boo)
      boo ? (this.$set(this.form, 'istime', 1)) : (this.$set(this.form, 'istime', 2))
      // console.log('form', { ...this.form })
    },
    formOrtherValidate() {
      let boo = true
      const { car_list, predict_loading_date, predict_unloading_date } = this.form
      if (!car_list || !car_list.length) {
        this.$message({
          type: 'error',
          message: '请选择车辆！'
        });
        boo = false
      } else if (new Date(predict_loading_date).getTime() > new Date(predict_unloading_date).getTime()) {
        this.$message({
          type: 'error',
          message: '装货日期不能晚于卸货日期！'
        });
        boo = false
      }
      return boo
    },
    setOptions({ contract, car_type, pricing, additional_fee_options }) {
      // 储存车辆类型用于检索
      if (car_type && car_type.length) {
        this.sformCtrl.map(c => {
          if (c.keyName == 'car_type') {
            c.options = car_type.map(v => {
              return {
                label: v.name,
                value: v.name,
              }
            })
          }
        })
      }

      this.formCtrl.map(c => {
        if (c.keyName == 'contractid' && contract && contract.length) {
          this.contract = contract
          c.options = contract.map(v => {
            return {
              label: v.con_num + '-' + v.shname,
              value: v.id,
              className: (Number(v.unton) >= Number(v.ton) && Number(v.ton) != 0 && v.isstatus == 2) ? 'excess' : '',
            }
          })
          // console.log({...this.form})
          if (this.form.contractid) {
            contract.map(v => {
              if (this.form.contractid == v.id) {
                this.$set(this.form, 'shname', v.shname)
                this.$set(this.form, 'shipperid', v.shipperid)
                this.$set(this.form, 'name', v.name)
                this.$set(this.form, 'nid', v.nid)
                this.$set(this.form, 'pricing_id', v.pricing_id)
                this.$set(this.form, 'cprice', v.cprice)
                this.$set(this.form, 'dprice', v.dprice)
                this.$set(this.form, 'coaddress', v.coaddress)
                this.$set(this.form, 'enaddress', v.enaddress)
                // console.log({...v})
              }
            })
          }
        }
      })
      this.formCtrlOrder.map(c => {
        if (c.keyName == 'pricing_id') {
          this.setPricingOption(pricing, c.options, { value: 'id' })
        }
      })

      // 附加费用
      if (additional_fee_options && additional_fee_options.length) {
        const o = additional_fee_options
        o.map(v => {
          const ctrl = {
            label: v.authname,
            keyName: v.enname,
            type: "number",
          }
          this.formCtrlfee.push(ctrl)
        })
      }
    },
    getOptions(params = {}) {
      this.post(`contract/addourcar`, params, this.setOptions, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from)
    fromPath = from.fullPath
    next()
  },
  created() {
    //计价方式和运费单价不可修改
    // this.formCtrlOrder.map(c => {
    //   if (c.keyName == 'pricing_id' || c.keyName == 'cprice') {
    //     c.viewMode = true
    //   }
    // })
    // console.log(this.formCtrlOrder)

    // 面包屑
    const path = this.$route.path
    // console.log(path)
    // console.log(fromPath)
    if (path === '/contract/addorder') {
      // 来自合同运单
      this.breadcrumb[0] = { name: "合同管理", path: fromPath }
      this.breadcrumb[1] = { name: "合同列表", path: fromPath }
    }

    // 合同id固定
    const { contractid } = this.$route.query
    if (contractid) {
      this.$set(this.form, 'contractid', contractid)
      this.formCtrl.map(v => {
        if (v.keyName === 'contractid') {
          v.viewMode = true
        }
      })
    }
  },
  mounted() {
    // console.log('form', { ...this.form })
    // console.log('formCtrl', [...this.formCtrl])
    this.getOptions({ userid: this.user.id });
    this.getCar();
  },
};
</script>

<style lang="less">
@tuiSize: 15px;

.contractid.el-select-dropdown.el-popper {

  .el-select-dropdown__list {

    .excess {
      position: relative;
      display: flex;
      align-items: center;

      &::after {
        content: '';
        display: inline-block;
        width: @tuiSize;
        height: @tuiSize;
        background: url(../../../assets/img/icon_excess.png) no-repeat center center;
        background-size: @tuiSize;
        margin-left: 5px;
      }
    }
  }
}
</style>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.choose {
        display: flex;

        .el-form-item__content {
          flex: 1;
        }
      }

      &.br {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: '关';
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: '开';
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;
}

/deep/ .sinput {
  .fillet {
    padding: 0;
    box-shadow: none;
  }

  .retrieval {
    margin: 0;

    .el-form-item__content {
      .el-input {
        width: 150px !important;
      }
    }

    .el-form {
      margin-bottom: 0px !important;
    }

    .el-form-item {
      margin: 0 0 10px 0;
    }
  }



}
</style>
